/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { UserProfileDropdown } from "./dropdowns/UserProfileDropdown";
import {AEOverlayTrigger} from "../../../../_emywork/AEOverlayTrigger";
import {useIntl} from "react-intl";
import {AESVG} from "../../../../_emywork/components/svg";
import {AEAvatar} from "../../../../_emywork/components/AEAvatar";
import {shallowEqual, useSelector} from "react-redux";

export function QuickUserToggler() {
  // const { user } = useSelector((state) => state.auth);
  const {formatMessage} = useIntl();
  const uiService = useHtmlClassService();
  const {authUser} = useSelector( ({auth}) => ({ authUser:auth.user }), shallowEqual );

  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
    };
  }, [uiService]);

  return (
    <>
      {layoutProps.offcanvas && (
        <AEOverlayTrigger
          overlay={<Tooltip id="quick-user-tooltip">{formatMessage({id:"USER_PROFILE"})}</Tooltip>}
          placement={'bottom'}
        >
          <div
            // className="btn btn-icon btn-clean btn-lg w-40px h-40px"
            // className="btn btn-icon btn-icon-mobile w-auto btn-clean d-flex align-items-center btn-lg px-2"
            className="btn btn-light font-weight-bold d-flex align-items-center ml-5 btn-sm"
            id="kt_quick_user_toggle"
            // data-placement="bottom"
            // data-container="body"
            // data-boundary="window"
          >
            <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">
              {formatMessage({id: 'HI'})+formatMessage({id: ','})}
            </span>
            <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-1">
              @{authUser.username}
            </span>
            <AEAvatar
              entity={authUser}
              overlay={false}
              size={30}
              svgProps={{
                className: `h-75 align-self-center`
              }}
            />
            {/*<AESVG*/}
            {/*  path={'/General/User.svg'}*/}
            {/*  size={'lg'}*/}
            {/*/>*/}
          </div>
        </AEOverlayTrigger>
      )}

      {!layoutProps.offcanvas && <UserProfileDropdown />}
    </>
  );
}
